import React from "react";

import ProductViewManage from "../../../Components/GMS/Products/ProductViewManage";

function ProductView(props) {
  const { params } = props.match;
  return (
    <React.Fragment>
      <ProductViewManage productid={params.id} />
    </React.Fragment>
  );
}

export default ProductView;
